<template>
  <div class="record-row">
    <!-- Date Separator -->
    <div v-if="showDateSeparator" class="date-separator">
      <div class="date-badge">
        <a-icon type="calendar" />
        <span class="date-text">{{ record.created_at.substring(0, 10) }}</span>
      </div>
    </div>

    <!-- Record Card -->
    <div class="record-card" @click="openCell">
      <div class="record-content">
        <div class="record-name">{{ record.name }}</div>
        <div class="record-meta">
          <div class="meta-item">
            <span class="meta-label">总数</span>
            <span class="meta-value">{{ record.item_count }}</span>
            <span class="meta-unit">只</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">创建时间</span>
            <span class="meta-time">{{ record.created_at }}</span>
          </div>
        </div>
      </div>
      <div class="record-actions">
        <a-button
          v-if="showDelete"
          type="link"
          class="delete-btn"
          @click.stop="deleteRecord"
        >
          <a-icon type="delete" />
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      required: true,
    },
    showDateSeparator: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 打开记录详情
    openCell() {
      this.$emit('open-cell', this.record.id);
    },
    // 删除记录
    deleteRecord() {
      this.$emit('delete-record', this.record.id);
    },
  },
};
</script>

<style scoped>
.record-row {
  margin-bottom: 16px;
}

/* Date Separator */
.date-separator {
  margin-bottom: 12px;
  margin-top: 8px;
}

.date-separator:first-child {
  margin-top: 0;
}

.date-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: #fff;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.3);
}

.date-badge .anticon {
  font-size: 14px;
}

.date-text {
  letter-spacing: 0.5px;
}

/* Record Card */
.record-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  transition: all 0.25s ease;
  cursor: pointer;
}

.record-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #d9d9d9;
  transform: translateY(-2px);
}

.record-content {
  flex: 1;
}

.record-name {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 10px;
}

.record-meta {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.meta-label {
  font-size: 12px;
  color: #8c8c8c;
}

.meta-value {
  font-size: 18px;
  font-weight: 700;
  color: #1890ff;
}

.meta-unit {
  font-size: 12px;
  color: #8c8c8c;
}

.meta-time {
  font-size: 13px;
  color: #595959;
}

.record-actions {
  flex-shrink: 0;
  margin-left: 16px;
}

.delete-btn {
  color: #bfbfbf;
  padding: 8px;
  transition: all 0.2s;
}

.delete-btn:hover {
  color: #ff4d4f;
}

/* Responsive */
@media (max-width: 576px) {
  .record-card {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .record-actions {
    margin-left: 0;
    margin-top: 12px;
    align-self: flex-end;
  }
  
  .record-meta {
    flex-direction: column;
    gap: 8px;
  }
}
</style>